import type { ReactNode } from "react";
import React, { createContext, useEffect, useState } from "react";
import { entitlementClient } from "store/graphql/apollo/clients";
import { useGetEntitlementsLazyQuery } from "store/graphql/codegen/auto-gen/entitlements";

type SubscriptionEntitlement = {
    subscription_id: string;
    feature_id: string;
    feature_name: string;
    feature_type: "SWITCH" | "RANGE" | "QUANTITY";
    value: string;
    name: string;
    is_overridden: boolean;
    is_enabled: boolean;
    object: string;
    __typename: string;
};

// Create the context
const EntitlementsContext = createContext<string[] | undefined>(undefined);

// Create the provider component
export const EntitlementsProvider = ({ children }: { children: ReactNode }) => {
    // Simulated feature flags
    const [entitlements, setEntitlements] = useState<string[]>(["build"]);

    const [getEntitlements] = useGetEntitlementsLazyQuery({
        client: entitlementClient,
        fetchPolicy: "no-cache"
    });

    useEffect(() => {
        const productId = localStorage.getItem("productId") ?? "XrYhKUxuz";
        getEntitlements({
            context: {
                headers: {
                    "sec-fetch-dest": "empty",
                    "sec-fetch-mode": "cors",
                    "sec-fetch-site": "cross-site"
                }
            },
            variables: {
                input: {
                    productId
                }
            },
            onCompleted: (data: any) => {
                setEntitlements([
                    ...data?.getEntitlements?.entitlements?.map(
                        (entitlement: SubscriptionEntitlement) => entitlement.feature_id
                    ),
                    "analyze",
                    "setup",
                    "dashboard",
                    "reports"
                ]);
            },
            onError: (data: any) => {
                console.log("error", data);
            }
        });
    }, []);

    return <EntitlementsContext.Provider value={entitlements}>{children}</EntitlementsContext.Provider>;
};

export default EntitlementsContext;
